// extracted by mini-css-extract-plugin
export default {"cell":"TableCheckboxCell_cell__ETIAh"};